import React from 'react';
import FAQ from '../components/FAQ';

const FAQPage = () => {
  return (
    <div className="pt-5 mt-5">
      <FAQ />
    </div>
  );
};

export default FAQPage;